import axios from 'axios'
import { apiURL } from '@/config'
import router from '@/router'

const isBlockedUser = (user) => {
  if (!user) return true
  const blocked = user.bloqueado
  return blocked === true || blocked === 1 || blocked === '1'
}

const normalizeUsers = (users) => {
  if (!Array.isArray(users)) return []

  return users
    .filter(user => !isBlockedUser(user))
    .sort((a, b) => {
      const nameA = String((a && a.name) || '')
      const nameB = String((b && b.name) || '')
      return nameA.localeCompare(nameB, 'pt-BR')
    })
}

const extractResponseData = (response) => {
  return response && response.data ? response.data.data : []
}

const requestUsersWithFallback = (endpoints, index = 0) => {
  if (index >= endpoints.length) {
    return Promise.reject(new Error('users_not_available'))
  }

  return axios.get(`${apiURL}${endpoints[index]}`).then(extractResponseData).catch((error) => {
    const status = error && error.response ? error.response.status : null
    const canFallback = index < endpoints.length - 1 && (status === 404 || status === 405)

    if (canFallback) {
      return requestUsersWithFallback(endpoints, index + 1)
    }

    return Promise.reject(error)
  })
}

const users = {
  namespaced: true,
  state: {
    users: []
  },
  mutations: {
    SET_USERS (state, payload) {
      state.users = payload
    }
  },
  actions: {
    loadUsers ({ commit, dispatch }, payload) {
      dispatch('utils/showLoading', {}, { root: true })
      axios.get(`${apiURL}/users`).then((response) => {
        commit('SET_USERS', response.data.data)
        dispatch('utils/hideLoading', {}, { root: true })
      }, (error) => {
        const isForbidden = error && error.response && error.response.status === 403
        dispatch('utils/showSnackbar', {
          text: isForbidden ? 'Sem permissão para visualizar usuários.' : 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
        if (isForbidden) {
          router.push('/')
        }
      })
    },
    loadAssignableUsers ({ commit, dispatch }) {
      dispatch('utils/showLoading', {}, { root: true })

      requestUsersWithFallback(['/pagamentos/aprovadores', '/users', '/usuarios']).then((users) => {
        commit('SET_USERS', normalizeUsers(users))
        dispatch('utils/hideLoading', {}, { root: true })
      }).catch((error) => {
        commit('SET_USERS', [])
        const status = error && error.response ? error.response.status : null

        dispatch('utils/showSnackbar', {
          type: 'error',
          text: status === 403 ? 'Sem permissão para carregar usuários responsáveis.' : 'Não foi possível carregar a lista de usuários.'
        }, { root: true })
        dispatch('utils/hideLoading', {}, { root: true })
      })
    }
  },
  getters: {
    users (state) {
      return state.users
    }
  }
}

export default users



// WEBPACK FOOTER //
// ./src/vuex/modules/users.js